import { render, staticRenderFns } from "./dialog-informationToUpdate.vue?vue&type=template&id=4d10f2dd"
import script from "./dialog-informationToUpdate.vue?vue&type=script&lang=js"
export * from "./dialog-informationToUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports